
import { useSEO, generateServiceSchema } from '../../../utils/seo';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import WhySmallBusinessesNeedWebsitesSection from './components/WhySmallBusinessesNeedWebsitesSection';
import ProcessSection from './components/ProcessSection';
import ServicesDetailSection from './components/ServicesDetailSection';
import BenefitsSection from './components/BenefitsSection';
import CostSection from './components/CostSection';
import FeatureComparisonSection from './components/FeatureComparisonSection';
import LocalExpertiseSection from './components/LocalExpertiseSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';

export default function GetSmallBusinessWebsitePage() {
  useSEO({
    title: 'Get a Small Business Website El Paso | Professional Web Design | David\'s Website Design',
    description: 'Get a professional small business website in El Paso, TX. We create mobile-responsive, SEO-optimized websites that generate leads and grow your business. Free consultation, turnkey solutions, and expert local support at 1000 Duskin Dr.',
    keywords: 'get small business website el paso, small business web design, professional website el paso, business website design, affordable web design el paso',
    schema: generateServiceSchema(
      'Small Business Website Design El Paso',
      'Professional website design services for small businesses in El Paso, TX. We create custom, mobile-responsive websites that help local businesses generate leads and grow their online presence.'
    )
  });

  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Navbar />
      <main>
        <HeroSection />
        <IntroSection />
        <WhySmallBusinessesNeedWebsitesSection />
        <ProcessSection />
        <ServicesDetailSection />
        <BenefitsSection />
        <CostSection />
        <FeatureComparisonSection />
        <LocalExpertiseSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
